import { createAction } from 'redux-actions';

export const SET_ERROR_STATE = 'ERROR.SET_ERROR_STATE';
export const setErrorState = createAction(SET_ERROR_STATE);

export const SET_UNAUTHORIZED_ERROR_STATE =
  'ERROR.SET_UNAUTHORIZED_ERROR_STATE';
export const setUnauthorizedErrorState = createAction(
  SET_UNAUTHORIZED_ERROR_STATE
);

export const CLEAR_ERROR_STATE = 'ERROR.CLEAR_ERROR_STATE';
export const clearErrorState = createAction(CLEAR_ERROR_STATE);
